import { useState } from "react";
import { Container } from "react-bootstrap";
import FreelancerserplaceNavbar from "../../signup/SubComponents/FreelancerserplaceNavbar";
import RegisterModal from "../../signup/RegisterModal";
import Footer from "../../signup/SubComponents/Footer";
import { MockTimetracking } from "./Components/MockScreens";

const TimetrackingLandingpage = () => {
  const [showRegister, setShowRegister] = useState(false);

  const features = [
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
        </svg>
      ),
      title: "Start & Stop Timer",
      text: "Track time with a single click. Start a timer when you begin, stop when you're done. Simple as that.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
      ),
      title: "Project-linked Entries",
      text: "Assign every time entry to a project and task. Build an accurate log of where your hours actually go.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
      ),
      title: "Billable Hours",
      text: "Mark entries as billable and use them as the basis for your invoices. Know exactly what to charge.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
        </svg>
      ),
      title: "Daily & Weekly View",
      text: "See your tracked hours at a glance. Spot over- or under-booked days and keep your schedule balanced.",
    },
  ];

  return (
    <>
      <RegisterModal show={showRegister} setShow={setShowRegister} showLoginForm={false} />
      <FreelancerserplaceNavbar />

      {/* Hero */}
      <div className="lp-hero-bg">
        <Container>
          <div style={{
            display: "grid", gridTemplateColumns: "1fr 1fr",
            gap: "3rem", alignItems: "center",
            paddingTop: "5rem", paddingBottom: "5rem",
            position: "relative",
          }}>
            <div className="yellowdotWelcome" />
            <div className="greendotWelcome" />
            <div>
              <div className="lp-badge">Time Tracking</div>
              <h1 className="lp-hero-title">
                Track your time, <span style={{ color: "#007BFF" }}>bill every hour</span>
              </h1>
              <p className="lp-hero-subtitle">
                Stop guessing how long things take. FreelancersPlace gives you accurate time logs linked directly to your projects and invoices.
              </p>
              <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "center" }}>
                <button className="lp-cta-btn btn btn-primary" onClick={() => setShowRegister(true)}>
                  Try now for free
                </button>
                <a href="https://demo.freelancersplace.net" target="_blank" rel="noreferrer" className="lp-demo-link">
                  View demo →
                </a>
              </div>
              <div className="lp-trust-badges">
                <span>✓ 30-day free trial</span>
                <span>✓ No credit card required</span>
              </div>
            </div>

            <div>
              <div className="reddotWelcome" />
              <MockTimetracking />
            </div>
          </div>
        </Container>
      </div>

      {/* Feature grid */}
      <div className="lp-section-alt">
        <Container>
          <div style={{ paddingTop: "4rem", paddingBottom: "4rem" }}>
            <div style={{ textAlign: "center", marginBottom: "3rem" }}>
              <span className="blueSubheaderTop">Everything you need</span>
              <h2 className="landingpageHeader" style={{ fontWeight: 400, marginTop: "0.5rem" }}>
                Time tracking that works for you
              </h2>
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: "1.25rem",
            }}>
              {features.map(({ icon, title, text }) => (
                <div key={title} style={{
                  background: "#fff",
                  border: "1px solid #e8edf5",
                  borderRadius: "1rem",
                  padding: "1.5rem",
                  transition: "box-shadow 0.15s, transform 0.15s",
                }}
                  onMouseOver={e => { e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,0,0,0.1)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
                  onMouseOut={e => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "none"; }}
                >
                  <div style={{
                    width: "44px", height: "44px", borderRadius: "10px",
                    background: "#e8f1ff", display: "flex", alignItems: "center",
                    justifyContent: "center", color: "#007BFF", marginBottom: "1rem",
                  }}>
                    {icon}
                  </div>
                  <h4 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "1rem", marginBottom: "0.5rem" }}>
                    {title}
                  </h4>
                  <p className="landingpageDescriptions" style={{ marginBottom: 0 }}>{text}</p>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>

      {/* CTA */}
      <Container>
        <div style={{
          textAlign: "center", padding: "5rem 1rem",
          borderBottom: "1px solid #f0f0f0",
        }}>
          <h2 className="landingpageHeader" style={{ fontWeight: 400 }}>
            Ready to take control of your time?
          </h2>
          <p className="landingpageDescriptions" style={{ maxWidth: "480px", margin: "0 auto 2rem" }}>
            Join freelancers who use FreelancersPlace to track hours accurately and bill clients with confidence.
          </p>
          <button className="lp-cta-btn btn btn-primary" onClick={() => setShowRegister(true)}>
            Start free trial
          </button>
        </div>
      </Container>

      <Footer />
    </>
  );
};

export default TimetrackingLandingpage;
